import React, { useEffect, useState } from "react";
import { fetchTransactions, createTransaction } from "../api.js";
import TransactionList from "../components/TransactionList.jsx";

export default function AdminPage() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const [name, setName] = useState("");
  const [comment, setComment] = useState("");
  const [type, setType] = useState("out");
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState("");
  const [receipt, setReceipt] = useState(null);

  const [items, setItems] = useState([]);

  // useEffect(() => {
  //   if (loggedIn) {
  //     fetchTransactions().then(setItems);
  //   }
  // }, [loggedIn]);
  const [savedNames, setSavedNames] = useState([]);
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (loggedIn) {
      fetchTransactions().then((data) => {
        setItems(data);

        // Extract unique names
        const uniqueNames = Array.from(new Set(data.map((t) => t.name)));
        setSavedNames(uniqueNames);
      });
    }
  }, [loggedIn]);

  function handleLogin(e) {
    e.preventDefault();
    if (password === "admin") {
      setLoggedIn(true);
      setPassword("");
      setError("");
    } else {
      setError("Wrong password");
    }
  }

  function handleFileChange(e) {
    const file = e.target.files[0];
    if (!file) {
      setReceipt(null);
      return;
    }
    // ✅ Allowed file types
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      alert("Only JPEG, JPG, or PNG files are allowed.");
      e.target.value = ""; // reset input
      // setReceipt(null);
      return;
    }
    // Validate file size (max 2MB)
    //২। এখানে ক্লায়েন্ট সাইডে।
    if (file.size > 2 * 1024 * 1024) {
      alert("Image size must not exceed 2MB.");
      // setError("Receipt must be less than 2MB");
      setReceipt(null);
    } else {
      setError("");
      setReceipt(file);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (!name || !amount || !date) {
      setError("Name, amount, and date are required");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("comment", comment);
    formData.append("type", type);
    formData.append("amount", amount);
    formData.append("date", date);
    if (receipt) formData.append("receipt", receipt);

    const created = await createTransaction(formData);
    setItems((prev) => [created, ...prev]); // real-time update

    setName("");
    setComment("");
    setType("out");
    setAmount("");
    setDate("");
    setReceipt(null);
    setError("");
  }

  if (!loggedIn) {
    return (
      <div>
        <h2>Admin Login</h2>
        <form onSubmit={handleLogin}>
          <input
            type="password"
            placeholder="Password (admin)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit">Login</button>
        </form>
        {error && <p>{error}</p>}
      </div>
    );
  }

  return (
    <div>
      <div
        style={{
          border: "1px solid black",
          width: "550px",
          padding: "20px",
          marginBottom: "20px",
        }}
      >
        <h2>Add / Minus Monthly Money</h2>

        <form onSubmit={handleSubmit}>
          <div>
            <label>Name of expense or deposit:</label>
            {/* <input value={name} onChange={(e) => setName(e.target.value)} />
             */}
            <input
              value={name}
              onChange={(e) => {
                const value = e.target.value;
                setName(value);

                if (value.trim() === "") {
                  setSuggestions([]);
                  return;
                }

                const matches = savedNames.filter((n) =>
                  n.toLowerCase().includes(value.toLowerCase())
                );

                setSuggestions(matches);
              }}
            />
            {suggestions.length > 0 && (
              <div>
                {suggestions.map((s, i) => (
                  <div
                    key={i}
                    onClick={() => {
                      setName(s);
                      setSuggestions([]);
                    }}
                  >
                    {s}
                  </div>
                ))}
              </div>
            )}
          </div>
          <br />
          <br />
          <br />
          <div>
            <label>Comment:</label>
            <input
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </div>
          <br />
          <div>
            <label>Type (in/out):</label>
            <select value={type} onChange={(e) => setType(e.target.value)}>
              <option value="in">In (Deposit)</option>
              <option value="out">Out (Expense)</option>
            </select>
          </div>
          <br />

          <div>
            <label>Amount:</label>
            <input
              type="number"
              step="0.01"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>
          <br />

          <div>
            {/* ৩। এখানে ক্লায়েন্ট সাইডে। */}
            <label>Receipt Picture(.jpeg/.jpg.png) (max 2MB):</label>
            <input type="file" accept="image/*" onChange={handleFileChange} />
          </div>
          <br />

          <div>
            <label>Date:</label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
          <br />

          <button
            type="submit"
            style={{
              marginLeft: "250px",
              padding: "10px 20px",
              fontSize: "16px",
              borderRadius: "5px",
              // border: "none",
              backgroundColor: "#63A361",

              color: "black",
              // border: "none",
              // borderRadius: "4px",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              // color: "black",
              "--hover-color": "blue",
              "--hover-opacity": 0.5,
            }}
          >
            Add
          </button>
        </form>

        <h2 style={{ color: "red",

         }}>{error && <p>{error}</p>}</h2>
      </div>

      <h3>All Transactions</h3>
      <TransactionList items={items} showReceipt={true} />
    </div>
  );
}
